import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
//icons
import { BsSearch } from 'react-icons/bs';
//constant
import { choicesInvoice } from "constants";
//components
import CustomInput from 'components/backoffice/customInput';
import SearchTable from 'components/backoffice/table/SearchTable';
import { SelectInputCustom } from 'components/input';

const FiltersTableInvoices = ({ formFilter, setFormFilter, handleClear, t, page, setPage }) => {
  const choices = choicesInvoice(t);
  const handleSearch = (e, key) => {
    if (page > 1 && e !== '') setPage(1);
    setFormFilter((prevFormFilter) => ({ ...prevFormFilter, [key]: e }));
  };

  return (
    <SearchTable multipleInput={true} handleClear={handleClear} placeholder={t('searchNroName')}>
      <Form className="d-flex flex-column flex-lg-row justify-content-between form-filter-list gap-3">
        <SelectInputCustom
          value={formFilter.status}
          onCheckedItem={(e) => handleSearch(e, 'status')}
          choices={choices}
        />
        <CustomInput
          handleKeyDown={true}
          type="text"
          placeholder={t('search')}
          value={formFilter.search}
          onChange={(e) => handleSearch(e, 'search')}
          icon={<BsSearch color="#161A25" className="icon-search" />}
        />
      </Form>
    </SearchTable>
  )
}

FiltersTableInvoices.propTypes = {
  formFilter: PropTypes.object,
  handleClear: PropTypes.func,
  setFormFilter: PropTypes.func,
  t: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func
};


export default FiltersTableInvoices;